import { render, staticRenderFns } from "./PaymentRegulation.vue?vue&type=template&id=320c4b86&scoped=true"
import script from "./PaymentRegulation.vue?vue&type=script&lang=js"
export * from "./PaymentRegulation.vue?vue&type=script&lang=js"
import style0 from "./PaymentRegulation.vue?vue&type=style&index=0&id=320c4b86&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c4b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('320c4b86')) {
      api.createRecord('320c4b86', component.options)
    } else {
      api.reload('320c4b86', component.options)
    }
    module.hot.accept("./PaymentRegulation.vue?vue&type=template&id=320c4b86&scoped=true", function () {
      api.rerender('320c4b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaymentRegulation.vue"
export default component.exports